"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateNotEmpty = void 0;
function ValidateNotEmpty(value) {
    if (typeof value !== "string")
        return false;
    value = value.trim();
    return value.length > 0;
}
exports.ValidateNotEmpty = ValidateNotEmpty;
//# sourceMappingURL=ValidationNotEmpty.js.map